var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.show
      ? _c("div", { staticClass: "action-panel" }, [
          _c("div", { staticClass: "action-panel__content" }, [
            _c(
              "button",
              {
                class: [
                  "action-panel__close",
                  { "click-down": _vm.closeClick },
                  { "click-up": _vm.closeClick === false },
                ],
                attrs: { "data-cy": "panel-join-close" },
                on: {
                  click: _vm.close,
                  mousedown: _vm.closeDown,
                  mouseup: _vm.closeUp,
                  touchstart: _vm.closeDown,
                  touchend: _vm.closeUp,
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "14",
                      height: "14",
                      viewBox: "0 0 14 14",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M1 1L13 13",
                        stroke: "black",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M13 1L1 13",
                        stroke: "black",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "action-panel__head action-panel--invite" },
              [
                _c("div", { staticClass: "action-panel__invite" }, [
                  _c("div", [
                    _c("img", {
                      attrs: {
                        src: _vm.$cdn("/img/ui/invite-friends.svg"),
                        alt: "Invite friends",
                        width: "24",
                        height: "25",
                      },
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("Invite Friends & Followers")]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("img", {
                      attrs: {
                        src: _vm.community.logo,
                        alt: _vm.community.name + " logo",
                        width: "59",
                        height: "59",
                      },
                    }),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("To "),
                      _c("span", { staticClass: "u-bold" }, [
                        _vm._v(_vm._s(_vm.community.name)),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "action-panel__search--instructions" }, [
              _vm._v(
                "Search your followers by name or " +
                  _vm._s(_vm.$root.brand.name) +
                  " username below and click to select. Or type an email address and press enter."
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "action-panel__invite-recipients" }, [
              _c("div", { staticClass: "to" }, [
                _vm._v("\n                    To:\n                "),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "action-panel__invite-recipients--list" },
                [
                  _vm._l(_vm.recipients, function (recipient, index) {
                    return _c("div", { staticClass: "recipient" }, [
                      recipient.username
                        ? _c("p", { staticClass: "u-color-black" }, [
                            _vm._v(_vm._s(recipient.username)),
                          ])
                        : recipient.name
                        ? _c("p", { staticClass: "u-color-black" }, [
                            _vm._v(_vm._s(recipient.name)),
                          ])
                        : _c("p", { staticClass: "u-color-black" }, [
                            _vm._v(_vm._s(recipient.email)),
                          ]),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "delete-recipient",
                        attrs: {
                          src: _vm.$cdn("/img/ui/icon-remove-recipient.svg"),
                          alt: "Remove recipient",
                          width: "9",
                          height: "8",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.deleteRecipient(index)
                          },
                        },
                      }),
                    ])
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "action-panel__invite-search" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.search,
                          expression: "search",
                        },
                      ],
                      ref: "search",
                      staticClass:
                        "c-textbox c-textbox--invite u-width-full u-m-b0",
                      attrs: {
                        type: "text",
                        placeholder: "Name, Username or Email",
                      },
                      domProps: { value: _vm.search },
                      on: {
                        keyup: _vm.getInput,
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.search = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "action-panel__clear-search",
                      class: { active: _vm.isActive },
                      attrs: {
                        src: _vm.$cdn("/img/ui/icon-close-black.svg"),
                        alt: "Remove text",
                        width: "25",
                        height: "25",
                      },
                      on: { click: _vm.clearInput },
                    }),
                  ]),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { ref: "members", staticClass: "action-panel__members-wrap" },
              _vm._l(_vm.members, function (member, index) {
                return _c(
                  "div",
                  {
                    key: member.id,
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.selectUser($event, index)
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "action-panel__user",
                        attrs: { href: "#", "data-id": member.id },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.$root.cloudinaryUrl + member.avatar,
                            width: "50",
                            height: "50",
                            alt: member.name,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "action-panel__user--details" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "action-panel__members action-panel__members--invite",
                              },
                              [
                                _c("p", [
                                  _vm._v(_vm._s(member.name)),
                                  _c("br"),
                                  _vm._v(" "),
                                  member.username
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "action-panel__members--tag",
                                        },
                                        [_vm._v("@" + _vm._s(member.username))]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: member.member,
                                        expression: "member.member",
                                      },
                                    ],
                                    staticClass: "action-panel__member",
                                    class: {
                                      show: member.member,
                                      blink: member.blink,
                                    },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.$cdn(
                                          "/img/icons/icon-members.svg"
                                        ),
                                        alt: "Members Icon",
                                        width: "24",
                                        height: "16",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("p", [_vm._v("Member")]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: member.accredited,
                                        expression: "member.accredited",
                                      },
                                    ],
                                    staticClass: "action-panel__accredited",
                                    class: { show: member.accredited },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.$cdn(
                                          "/img/ui/icon-accredited.svg"
                                        ),
                                        alt: "Accredited Icon",
                                        width: "8",
                                        height: "8",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("p", [_vm._v("Accredited")]),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "action-panel__footer" }, [
              _c(
                "a",
                {
                  staticClass: "c-btn c-btn--invite c-btn--invite-panel",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.sendInvitesModal.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Send Invites")]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }